import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConfigService } from '../config/config.service';
import { UnidadeMedida } from '../types/UnidadeMedida.type';
import { Instancia } from '../types/Instancia.type';

@Injectable({
  providedIn: 'root'
})
export class EmpresaService {

  constructor(private httpClient: HttpClient, private configService: ConfigService) { }
  
    getEmpresas() {
        return this.httpClient.get<UnidadeMedida[]>(this.configService.getApiUrlRoot() + "/empresas/");
    }
  
    getInstancias(){
      return this.httpClient.get<Instancia[]>(`${this.configService.getApiUrlRoot()}/empresas/instancias`)
    }
}
